import { Text, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useCSSVariable } from "uniwind";
import { cn, haversineDistanceKm } from "@/shared/lib/utils";
import { useUserLocation } from "@/shared/hooks/use-user-location";

type DistanceChipProps = {
  lat: number | null | undefined;
  lng: number | null | undefined;
  className?: string;
};

function formatDistance(km: number): string {
  if (km < 10) return `${km.toFixed(1)} km`;
  return `${Math.round(km)} km`;
}

export function DistanceChip({ lat, lng, className }: DistanceChipProps) {
  const { location } = useUserLocation();
  const [mutedForeground] = useCSSVariable(["--color-muted-foreground"]) as [
    string,
  ];

  if (!location || lat == null || lng == null) return null;

  const distanceKm = haversineDistanceKm(location.lat, location.lng, lat, lng);

  return (
    <View
      className={cn(
        "bg-surface flex-row items-center gap-1 self-start rounded-full py-1",
        className
      )}
      accessibilityLabel={`${formatDistance(distanceKm)} away`}
    >
      <Ionicons name="location-outline" size={12} color={mutedForeground} />
      <Text className="text-muted-foreground text-xs font-medium">
        {formatDistance(distanceKm)}
      </Text>
    </View>
  );
}
